import iconWallet from '../images/icon-wallet.svg';
import iconWalletGray from '../images/icon-wallet-gray.svg';
import iconMarket from '../images/icon-market.svg';
import iconMarketGray from '../images/icon-market-gray.svg';
import iconTrade from '../images/icon-trade.svg';
import iconTradeGray from '../images/icon-trade-gray.svg';
import iconFund from '../images/icon-fund.svg'
import iconFundGray from '../images/icon-fund-gray.svg'

import WalletViewController from '../controllers/WalletViewController';
import MarketView from '../views/MarketView';
import MarketViewController from '../controllers/MarketViewController';
import TradeView from '../views/TradeView';
import FundView from '../views/FundView';
import WalletView from '../views/WalletView';
import { Localize } from '../modules/localize/Localize';



export const GlobalSetting = {
    configKey: "",
    Setting: {
        HideOtherSymbol: false, //隐藏其他交易对设置 
        KLineTimeRangeSelected: 2,//当前K线时间范围选择
        TechnicalIndicatorSetting: { main: "MA", sub: {} }//K线图技术指标设置
    },

    set: (key, value) => {
        GlobalSetting.Setting[key] = value;
        GlobalSetting.save();
    },

    get: (key) => {
        return GlobalSetting.Setting[key];
    },

    save: () => {
        localStorage.setItem(GlobalSetting.configKey, JSON.stringify(GlobalSetting.Setting));
    },

    load: accountId => {
        GlobalSetting.configKey = "global_" + accountId;
        const str = localStorage.getItem(GlobalSetting.configKey);
        const item = JSON.parse(str);
        for (const setting in item) {
            const v = item[setting];
            GlobalSetting.Setting[setting] = v;
        }
    }
}

// export const Global = {
//     HideOtherSymbol: false, //隐藏其他交易对设置 
//     KLineTimeRangeSelected: 2,//当前K线时间范围选择
//     TechnicalIndicatorSetting: { main: "MA", sub: {} }//K线图技术指标设置
// }

// export const setGlobalSetting = (key, value) => {
//     Global[key] = value;
//     saveGlobalSetting()
// }

// export const loadGlobalSetting = (accountId) => {
//     configKey = "global_" + accountId;
//     const str = localStorage.getItem(configKey);
//     const item = JSON.parse(str);
//     for (const setting in item) {
//         const v = item[setting];
//         Global[setting] = v;
//     }
// }
// export const saveGlobalSetting = () => {
//     localStorage.setItem(configKey, JSON.stringify(Global));
// }

/**
 * CoinType
 */
export const CoinType = {
    ETH: 1,
    Tian: 2,
    Tong: 3,
    SOL: 4,
    Matic: 5,
    USDC: 6,
    USDT: 7,
    NEXG: 8
}

/**
 * WalletAccount
 */
export const WalletAccount = {
    DeFi: -2,
    All: -1,
    GameAccount: 0,
    TradeAccount: 1
}

export const WAIdToString = (id) => {
    for (const key in WalletAccount) {
        const waId = WalletAccount[key];
        if (id == waId) {
            return key;
        }
    }
    return "";
}

export const WAIdToName = (id) => {
    for (const key in Localize.WalletAccountName) {
        if (id == key) {
            return Localize.WalletAccountName[key];
        }
    }
    return "";
}

const FuncOpen = {
    wallet: true,
    fund: true,
    exchange: true,
    market: false,
    trade: false,
}

const IsFunctionOpen = (funcName) => {
    const open = FuncOpen[funcName];
    return open == true;
}

const MenuConfig = [
    { img: iconWallet, imgGray: iconWalletGray, text: "L:COMMON.Wallet", name: "wallet" },
    { img: iconFund, imgGray: iconFundGray, text: "L:COMMON.Funds", name: "fund" },
    { img: iconMarket, imgGray: iconMarketGray, text: "L:COMMON.Markets", name: "market" },
    { img: iconTrade, imgGray: iconTradeGray, text: "L:COMMON.Trade", name: "trade" },
]

const ViewConfig = {
    "wallet": { component: WalletView, controller: WalletViewController },
    "fund": { component: FundView, controller: WalletViewController },
    "market": { component: MarketView, controller: MarketViewController },
    "trade": { component: TradeView, controller: MarketViewController }
}

const WalletTypes = [
    { type: 0, name: "L:WalletAccountName.-1", walletId: WalletAccount.All },
    { type: 2, name: "L:WalletAccountName.1", walletId: WalletAccount.TradeAccount },
    { type: 1, name: "L:WalletAccountName.0", walletId: WalletAccount.GameAccount },
]

const MarketDetailTypes = [
    { type: 0, name: "委托订单" },
    { type: 1, name: "最新成交" },
    { type: 2, name: "Info" }
]

const Topics = {
    marketThumb: "/topic/market/thumb",
    marketTrade: "/topic/market/trade",
    marketQuotePrice: "/topic/market/quote_price",
    marketPlate: "/topic/market/plate",

    market_kLineData: (symbolName, rangeField) => `/topic/market/kline/${symbolName}/${rangeField}`,

    topicTrade: (symbolName) => `${Topics.marketTrade}/${symbolName}`,
    topicPlate: (symbolName, priceStep) => `${Topics.marketPlate}/${symbolName}/${priceStep}`,


    exchange_user_wallet: "/user/queue/wallet",
    exchange_user_trade: "/user/queue/trade",
    exchange_user_trans: "/user/queue/transaction",

}

const KLineTimeRange = {
    "1min": 60 * 1000,
    "5min": 5 * 60 * 1000,
    "15min": 15 * 60 * 1000,
    "30min": 30 * 60 * 1000,
    "1hour": 1 * 60 * 60 * 1000,
    "2hour": 2 * 60 * 60 * 1000,
    "4hour": 4 * 60 * 60 * 1000,
    "8hour": 8 * 60 * 60 * 1000,
    "12hour": 12 * 60 * 60 * 1000,
    "1week": 7 * 24 * 60 * 60 * 1000,
    "1day": 1 * 24 * 60 * 60 * 1000,
    "1mon": 1 * 30 * 24 * 60 * 60 * 1000

}

const OrderTypes = [
    {
        id: 0,
        name: "限价单",
        short: "限价",
        method: "GTC"
    },
    {
        id: 1,
        name: "市价单",
        short: "市价",
        method: "IOC"
    }
];

const OrderStatus = {
    Trading: 0,
    Completed: 1,
    Canceled: 2,
    Timeout: 3,
    Error: 4
}

export const SearchTimeScope = {
    OneDay: "OneDay",
    OneWeek: "OneWeek",
    OneMonth: "OneMonth",
    ThreeMonth: "ThreeMonth"
}

const MarketRecentDataLength = 40;

export const GetOrderType = (id) => {
    for (const key in OrderTypes) {
        if (id == OrderTypes[key].id) {
            return OrderTypes[key];
        }
    }
    return null;
}

export { KLineTimeRange, MenuConfig, ViewConfig, WalletTypes, Topics, MarketDetailTypes, OrderTypes, MarketRecentDataLength, OrderStatus, IsFunctionOpen }